var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount 2",
    clipPath: "url(#clip0_7750_935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1365 9.23314C17.0641 9.08496 17.0641 8.91502 17.1365 8.76687L17.8078 7.3935C18.1816 6.62882 17.8855 5.7174 17.1336 5.31848L15.7833 4.602C15.6376 4.52473 15.5377 4.3872 15.5092 4.22481L15.2451 2.71911C15.098 1.88078 14.3226 1.31744 13.48 1.43666L11.9664 1.65076C11.803 1.67382 11.6415 1.6213 11.523 1.50665L10.4243 0.443815C9.81258 -0.148002 8.85423 -0.148037 8.24252 0.443815L7.14382 1.50676C7.02527 1.62144 6.86373 1.67385 6.7004 1.65086L5.18682 1.43676C4.34396 1.31748 3.56877 1.88089 3.42171 2.71922L3.15762 4.22485C3.1291 4.38727 3.02923 4.52476 2.88357 4.60207L1.53323 5.31855C0.781383 5.71743 0.485228 6.62892 0.859008 7.3936L1.53031 8.76694C1.60273 8.91512 1.60273 9.08506 1.53031 9.23321L0.858972 10.6065C0.485193 11.3712 0.781348 12.2826 1.5332 12.6816L2.88354 13.398C3.02923 13.4753 3.1291 13.6128 3.15762 13.7752L3.42171 15.2809C3.55558 16.0441 4.20998 16.5793 4.96207 16.5792C5.03614 16.5792 5.11131 16.574 5.18686 16.5634L6.70043 16.3493C6.86366 16.3261 7.02531 16.3787 7.14385 16.4934L8.24252 17.5562C8.54844 17.8521 8.94086 18.0001 9.33341 18C9.72585 18 10.1185 17.8521 10.4243 17.5562L11.523 16.4934C11.6415 16.3787 11.8031 16.3263 11.9664 16.3493L13.48 16.5634C14.323 16.6826 15.098 16.1192 15.2451 15.2809L15.5092 13.7753C15.5377 13.6128 15.6376 13.4754 15.7833 13.398L17.1336 12.6816C17.8855 12.2827 18.1816 11.3712 17.8078 10.6065L17.1365 9.23314ZM7.25706 4.32828C8.30653 4.32828 9.16037 5.18211 9.16037 6.23159C9.16037 7.28107 8.30653 8.1349 7.25706 8.1349C6.20758 8.1349 5.35374 7.28107 5.35374 6.23159C5.35374 5.18211 6.20758 4.32828 7.25706 4.32828ZM6.27466 12.7928C6.1733 12.8942 6.04045 12.9448 5.90763 12.9448C5.77481 12.9448 5.64192 12.8942 5.5406 12.7928C5.33789 12.5901 5.33789 12.2614 5.5406 12.0587L12.3921 5.20718C12.5948 5.00447 12.9235 5.00447 13.1262 5.20718C13.3289 5.40989 13.3289 5.73856 13.1262 5.94127L6.27466 12.7928ZM11.4097 13.6718C10.3602 13.6718 9.50638 12.8179 9.50638 11.7685C9.50638 10.719 10.3602 9.86514 11.4097 9.86514C12.4592 9.86514 13.313 10.719 13.313 11.7685C13.313 12.8179 12.4592 13.6718 11.4097 13.6718Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4097 10.9033C10.9326 10.9033 10.5445 11.2914 10.5445 11.7684C10.5445 12.2455 10.9326 12.6336 11.4097 12.6336C11.8867 12.6336 12.2748 12.2455 12.2748 11.7684C12.2748 11.2914 11.8867 10.9033 11.4097 10.9033Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.25703 5.36646C6.77999 5.36646 6.39191 5.75454 6.39191 6.23158C6.39191 6.70861 6.77999 7.09673 7.25703 7.09673C7.73406 7.09673 8.12218 6.70864 8.12218 6.23158C8.12215 5.75458 7.73406 5.36646 7.25703 5.36646Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7750_935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferWhite);
export default __webpack_public_path__ + "static/media/offer_white.fccaf65ebf892125af2b951d3aba9890.svg";
export { ForwardRef as ReactComponent };